import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Dialog, DialogType, DialogFooter } from 'office-ui-fabric-react/lib/Dialog';
import { PrimaryButton, DefaultButton } from 'office-ui-fabric-react/lib/Button';
import clsx from 'clsx';
import { TextField } from 'office-ui-fabric-react/lib/TextField';
import { useStatementRejection } from '../../context/statement-rejection';
import SavingIndicator from '../../components/SavingIndicator';
import styles from './DimensionListReviewerDialog.style';

const DimensionListReviewerDialog = ({
  onDismiss,
  onSubmit,
  isSubmitting,
  approved,
  className,
  ...other
}) => {
  const { message, setRejectionMessage } = useStatementRejection();
  const [validationMessage, setValidationMessage] = useState();

  const handleInputChange = e => {
    setValidationMessage('');
    setRejectionMessage(e.target.value);
  };

  return (
    <Dialog
      dialogContentProps={{
        type: DialogType.normal,
        title: 'Pause Transactions',
        closeButtonAriaLabel: 'Close',
      }}
      modalProps={{
        className: clsx(styles.root, className),
      }}
      onDismiss={onDismiss}
      onSubmit={onSubmit}
      isSubmitting={isSubmitting}
      {...other}
    >
      {approved ? (
        <p className={styles.modalText}>
          Once approved, the list must be resubmitted if additional changes are necessary.
        </p>
      ) : (
        <>
          <p className={styles.modalText}>Please describe why the edits will be rejected.</p>
          <TextField
            name="message"
            multiline
            resizable={false}
            value={message}
            onChange={handleInputChange}
            required
            errorMessage={validationMessage}
          />
        </>
      )}
      <DialogFooter>
        <DefaultButton onClick={onDismiss} disabled={isSubmitting}>
          Cancel
        </DefaultButton>
        <PrimaryButton
          type="submit"
          disabled={isSubmitting}
          onClick={() => {
            if (!approved && message === '') {
              setValidationMessage('Required');
              return;
            }
            onSubmit();
          }}
        >
          {approved ? 'Approve' : 'Reject'}
        </PrimaryButton>
        {isSubmitting && <SavingIndicator className={styles.saving} />}
      </DialogFooter>
    </Dialog>
  );
};

DimensionListReviewerDialog.propTypes = {
  onDismiss: PropTypes.func,
  onSubmit: PropTypes.func,
  className: PropTypes.string,
  isSubmitting: PropTypes.bool,
  approved: PropTypes.bool.isRequired,
};

DimensionListReviewerDialog.defaultProps = {
  className: 'normal',
  onDismiss: null,
  onSubmit: null,
  isSubmitting: false,
};

export default DimensionListReviewerDialog;
